<template functional>
  <div class="social-icons">
    <ul>
      <li>
        <a href="#">
          <i class="uil uil-facebook-f"></i>
        </a>
      </li>
      <li>
        <a href="#">
          <i class="uil uil-linkedin"></i>
        </a>
      </li>
      <li>
        <a href="#">
          <i class="uil uil-instagram"></i>
        </a>
      </li>
      <li>
        <a href="#">
          <i class="uil uil-youtube"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'social-icons'
}
</script>
